import React from "react";
import TextField from "material-ui/TextField";
import IconButton from "material-ui/IconButton";
import firebase from "../../../lib/firebase";
import ViewHeadline from "material-ui/svg-icons/action/view-headline";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import RaisedButton from "material-ui/RaisedButton";
import "dragula/dist/dragula.min.css";
import dragula from "dragula";
import parallel from "async/parallel";
import Toggle from 'material-ui/Toggle';
import "./Setting.css";
import _ from "lodash";
import newId from "../../../lib/newid";

export default class Setting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            isShowMain: false,
            description: '',
            topics: [],
            deletedTopics: {}
        };
        this.asyncs = [];
    }

    componentDidMount() {
        this.startLive();
        dragula([document.querySelector('.Setting .container')]).on('drop', function (el, target, source, sibling) {
            var state = Object.assign(this.state);
            for (let i = 0; i < target.children.length; i++) {
                let d = target.children[i].dataset;
                let title = target.children[i].querySelector('.title input').value;

                let index = _.findIndex(state.topics, {key:d.key});
                state.topics[index].order = i+1;

            };
            this.setState(state);
        }.bind(this));
    }

    componentWillUnmount() {
        this.stopLive();
    }

    startLive() {
        if (!this.props.isNew) {
            firebase.database().ref(`campaign/${this.props.campaignId}/topics`).limitToLast(200).once('value').then(function (sp) {
                var data = [];
                sp.forEach(function (e) {
                    data.push(Object.assign({}, e.val(), {key: e.key}));
                });
                data.sort(function (o1, o2) {
                    return o1.order - o2.order;
                });
                this.setState({
                    topics: data
                });
            }.bind(this));
            firebase.database().ref(`campaign/${this.props.campaignId}/info`).once('value').then(function (sp) {
                this.setState({
                    title: sp.val().title,
                    description: sp.val().description,
                    isShowMain: sp.val().isShowMain === undefined ? false : sp.val().isShowMain
                });
            }.bind(this));
        } else {

        }
    }

    stopLive() {
    }

    saveHandler() {
        if (this.state.title === '' || this.state.title === undefined) {
            alert('제목은 필수입니다');
            return false;
        }
        if (this.props.isNew) {
            firebase.database().ref(`campaign/${this.props.campaignId}/info`).set({
                title: this.state.title,
                userKey: firebase.auth().currentUser.uid
            }, this.config.bind(this));
        } else {
            this.config.bind(this)();
        }
    }

    config() {

        setTopics.call(this);
        deleteTopics.call(this);
        setInfo.call(this);
        setHome.call(this);
        execute.call(this);

        function execute() {
            parallel(this.asyncs, function (err, results) {
                window.location.reload();
            }.bind(this));
        }


        function isNew(topic) {
            return topic.key.indexOf('new-') === 0;
        }

        function deleteTopics() {
            this.asyncs.push(
                function (callback) {
                    let deletedTopics = this.state.deletedTopics;
                    if(!deletedTopics){
                        return callback(null);
                    }
                    firebase.database().ref().update(deletedTopics).then(function () {
                        callback(null, `deleted`);
                    });
                }.bind(this));
        }

        function setTopics() {
            for (let i = 0; i < this.state.topics.length; i++) {
                let topic = this.state.topics[i];
                if (isNew(topic)) {
                    this.asyncs.push(
                        function (callback) {
                            (function (key, title, order, callback) {
                                firebase.database().ref(`/campaign/${this.props.campaignId}/topics`).push({
                                    title: title,
                                    order: order
                                }, function () {
                                    callback(null, title);;
                                });
                            }.bind(this, null, topic.title, topic.order, callback))()
                        }.bind(this)
                    );
                } else {
                    this.asyncs.push(
                        function (callback) {
                            (function (key, title, order, callback) {
                                firebase.database().ref(`campaign/${this.props.campaignId}/topics/${key}`).set({
                                    title: title,
                                    order: order
                                }, function () {
                                    callback(null, title);
                                });
                            }.bind(this, topic.key, topic.title, topic.order, callback))();
                        }.bind(this)
                    );
                }
            }
        }


        function setInfo() {
            this.asyncs.push(
                function (callback) {
                    (function (callback) {
                        firebase.database().ref(`campaign/${this.props.campaignId}/info`).update({
                            title: this.state.title,
                            description: this.state.description === undefined ? '' : this.state.description,
                            isShowMain: this.state.isShowMain
                        }).then(function (callback) {
                            callback(null);
                        }.bind(this, callback));
                    }.bind(this, callback))();
                }.bind(this)
            );
        }


        function setHome() {
            this.asyncs.push(
                function (callback) {
                    (function (callback) {
                        if (this.state.isShowMain === false) {
                            firebase.database().ref(`home/${this.props.campaignId}`).remove().then(function (callback) {
                                callback(null);
                            }.bind(this, callback));
                        } else {
                            firebase.database().ref(`home/${this.props.campaignId}`).update({
                                title: this.state.title,
                                description: this.state.description === undefined ? '' : this.state.description,
                                userKey: firebase.auth().currentUser.uid,
                                userDisplayName: firebase.auth().currentUser.displayName
                            }).then(function (callback) {
                                callback(null);
                            }.bind(this, callback));
                        }

                    }.bind(this, callback))();
                }.bind(this)
            );
        }


    }

    config2() {
        let target = document.querySelector('.Setting .container');
        for (let i = 0; i < target.children.length; i++) {
            let d = target.children[i].dataset;
            let title = target.children[i].querySelector('.title input').value;
            if (!d.key)
                continue;
            if (d.key.indexOf('new-') === 0) {
                this.asyncs.push(
                    function (callback) {
                        (function (key, title, order, callback) {
                            firebase.database().ref(`campaign/${this.props.campaignId}/topics`).push({
                                title: title,
                                order: order
                            }, function () {
                                callback(null, title);
                            });
                        }.bind(this, null, title, i + 1, callback))()
                    }.bind(this)
                );
            } else {
                this.asyncs.push(
                    function (callback) {
                        (function (key, title, order, callback) {
                            firebase.database().ref(`campaign/${this.props.campaignId}/topics/${key}`).set({
                                title: title,
                                order: order
                            }, function () {
                                callback(null, title);
                            });
                        }.bind(this, d.key, title, i + 1, callback))();
                    }.bind(this)
                );

            }
        }
        this.asyncs.push(
            function (callback) {
                (function (callback) {
                    firebase.database().ref(`campaign/${this.props.campaignId}/info`).update({
                        title: this.state.title,
                        description: this.state.description === undefined ? '' : this.state.description,
                        isShowMain: this.state.isShowMain
                    }).then(function (callback) {
                        callback(null);
                    }.bind(this, callback));
                }.bind(this, callback))();
            }.bind(this)
        );
        this.asyncs.push(
            function (callback) {
                (function (callback) {
                    if (this.state.isShowMain === false) {
                        firebase.database().ref(`home/${this.props.campaignId}`).remove().then(function (callback) {
                            callback(null);
                        }.bind(this, callback));
                    } else {
                        firebase.database().ref(`home/${this.props.campaignId}`).update({
                            title: this.state.title,
                            description: this.state.description === undefined ? '' : this.state.description,
                            userKey: firebase.auth().currentUser.uid,
                            userDisplayName: firebase.auth().currentUser.displayName
                        }).then(function (callback) {
                            callback(null);
                        }.bind(this, callback));
                    }

                }.bind(this, callback))();
            }.bind(this)
        );
        /*this.asyncs.push(
            function (callback) {
                (function (callback) {
                    let updates = {};
                    let data = {
                        title: this.state.title,
                        description: this.state.description,
                        isShowMain: this.state.isShowMain
                    };
                    updates[`campaign/${this.props.campaignId}/info`]
                }.bind(this, callback))();
            }.bind(this)
        );*/
        parallel(this.asyncs, function (err, results) {
            window.location.reload();
        });
    }


    render() {
        let topics = this.state.topics.map(function (e) {
            return (
                <tr key={e.key} data-key={e.key} id={"topics-" + e.key}>
                    <td style={{
                        cursor: 'n-resize',
                        width: '2rem'
                    }}>
                        <ViewHeadline color="#d2d2d2"/>
                    </td>
                    <td>
                        <TextField
                            className="title"
                            hintText="제목을 정해주세요"
                            defaultValue={e.title}
                            fullWidth={true}
                            onChange={function (key, e) {
                                let topics = Object.assign(this.state.topics);
                                let index = _.findIndex(topics, {key: key});
                                topics[index].title = e.target.value;
                                this.setState({topics: topics})
                            }.bind(this, e.key)}
                        />
                    </td>
                    <td style={{width: '1rem'}}>
                        <IconButton
                            onTouchTap={function (key) {
                                var state = Object.assign(this.state);
                                state.deletedTopics[`/campaign/${this.props.campaignId}/topics/${key}`] = null;
                                state.topics.splice(_.findIndex(state.topics, {key:key}),1);
                                this.setState(state);
                            }.bind(this, e.key)}
                            label="제거"
                        >
                            <DeleteIcon color={'#d2d2d2'}/>
                        </IconButton>
                    </td>
                </tr>
            );
        }.bind(this));
        let isShowMain = this.props.isNew ? '' : (
            <div>
                <label>메인노출</label>
                <Toggle label="노출합니다" className="toggle" labelPosition="right" onToggle={function (e, isToggle) {
                    this.setState({isShowMain: isToggle});
                }.bind(this)}
                        toggled={this.state.isShowMain}
                />
            </div>
        );
        return (
            <div className="Setting">
                <div>
                    <label>제목</label>
                    <TextField
                        onChange={function (e) {
                            this.setState({title: e.target.value})
                        }.bind(this)}
                        hintText="제목을 정해주세요"
                        fullWidth={true}
                        value={this.state.title}
                        inputStyle={{
                            fontSize: '2rem'
                        }}
                    />
                </div>
                <div>
                    <label>소개</label>
                    <TextField
                        onChange={function (e) {
                            this.setState({description: e.target.value})
                        }.bind(this)}
                        hintText="소개해주세요"
                        fullWidth={true}
                        multiLine={true}
                        value={this.state.description}
                    />
                </div>
                {isShowMain}
                <div>
                    <label></label>
                    <table style={{width: '100%'}}>
                        <tbody className="container" >{topics}</tbody>
                    </table>
                </div>
                <RaisedButton
                    style={{
                        marginLeft: '2.5rem',
                        marginTop: '0.5rem'
                    }}
                    onTouchTap={function () {
                        var maxOrder = 0;
                        this.state.topics.forEach(function (e) {
                            maxOrder = Math.max(maxOrder, e.order);
                        })
                        this.setState({
                            topics: this.state.topics.concat({title: '', order: maxOrder + 1, key: newId('new-')})
                        });
                    }.bind(this)}
                    label="토픽추가"
                >
                </RaisedButton>
                <div className="control" style={{
                    marginTop: '3rem',
                    textAlign: 'center',
                    borderTop: '1px solid #e6e6e6',
                    paddingTop: '3rem',
                    marginBottom: '4rem'
                }}>
                    <RaisedButton
                        onTouchTap={function () {
                            this.saveHandler();
                        }.bind(this)}
                        label="저장"
                        style={{marginRight: '1rem'}}
                    />
                    <RaisedButton
                        onTouchTap={function () {
                            window.location.reload();
                        }}
                        label="취소"
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/Setting.js